import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Split, MousePointerClick, CheckCircle2, X } from 'lucide-react';
import { useTheme } from '../styles/ThemeContext';
import { useComparison } from './ComparisonContext';
export function CompareTutorialModal() {
  const {
    isDark
  } = useTheme();
  const {
    isDedicatedCompareActive,
    hasSeenTutorial,
    markTutorialSeen
  } = useComparison();
  if (!isDedicatedCompareActive || hasSeenTutorial) return null;
  return <AnimatePresence data-id="element-549">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm p-6" data-id="element-550">
        <motion.div initial={{
        scale: 0.95,
        opacity: 0,
        y: 20
      }} animate={{
        scale: 1,
        opacity: 1,
        y: 0
      }} exit={{
        scale: 0.95,
        opacity: 0,
        y: 20
      }} className={`relative w-full max-w-lg rounded-2xl shadow-2xl border overflow-hidden ${isDark ? 'bg-slate-900 border-white/10' : 'bg-white border-gray-200'}`} data-id="element-551">
          {/* Header */}
          <div className={`px-6 py-4 border-b flex items-center justify-between ${isDark ? 'border-white/10 bg-white/5' : 'border-gray-100 bg-gray-50'}`} data-id="element-552">
            <div className="flex items-center gap-3" data-id="element-553">
              <div className={`p-2 rounded-lg ${isDark ? 'bg-cyan-500/20 text-cyan-400' : 'bg-teal-100 text-teal-600'}`} data-id="element-554">
                <Split className="w-5 h-5" data-id="element-555" />
              </div>
              <h2 className={`text-lg font-bold ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-556">
                Compare Mode
              </h2>
            </div>
            <button onClick={markTutorialSeen} className={`p-1.5 rounded-full transition-colors ${isDark ? 'hover:bg-white/10 text-white/50 hover:text-white' : 'hover:bg-gray-200 text-gray-400 hover:text-gray-600'}`} data-id="element-557">
              <X className="w-5 h-5" data-id="element-558" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6 space-y-6" data-id="element-559">
            <div className="flex gap-4" data-id="element-560">
              <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg ${isDark ? 'bg-white/10 text-white' : 'bg-gray-100 text-gray-900'}`} data-id="element-561">
                1
              </div>
              <div data-id="element-562">
                <h3 className={`font-bold mb-1 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-563">
                  Select Options
                </h3>
                <p className={`text-sm leading-relaxed ${isDark ? 'text-slate-400' : 'text-gray-600'}`} data-id="element-564">
                  Browse the gallery and click any two options you want to
                  compare side-by-side.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-565">
              <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg ${isDark ? 'bg-white/10 text-white' : 'bg-gray-100 text-gray-900'}`} data-id="element-566">
                2
              </div>
              <div data-id="element-567">
                <h3 className={`font-bold mb-1 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-568">
                  Start Comparison
                </h3>
                <p className={`text-sm leading-relaxed ${isDark ? 'text-slate-400' : 'text-gray-600'}`} data-id="element-569">
                  Once two items are selected, click "Start Comparison" to enter
                  the slider view.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-570">
              <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg ${isDark ? 'bg-white/10 text-white' : 'bg-gray-100 text-gray-900'}`} data-id="element-571">
                3
              </div>
              <div data-id="element-572">
                <h3 className={`font-bold mb-1 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-573">
                  Choose Winner
                </h3>
                <p className={`text-sm leading-relaxed ${isDark ? 'text-slate-400' : 'text-gray-600'}`} data-id="element-574">
                  Use the slider to compare details, then select your preferred
                  option to apply it to your design.
                </p>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className={`p-6 pt-2`} data-id="element-575">
            <button onClick={markTutorialSeen} className={`w-full py-3 rounded-xl font-bold text-sm shadow-lg transition-transform active:scale-[0.98] ${isDark ? 'bg-cyan-500 hover:bg-cyan-400 text-white' : 'bg-teal-600 hover:bg-teal-500 text-white'}`} data-id="element-576">
              Got it, let's start
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>;
}